import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UtilService {
  constructor() {}

  validarCNPJ(cnpj: string): boolean {
    // Remove os caracteres especiais (como pontos, barra e hífen)
    cnpj = cnpj.replace(/[^\d]+/g, "");

    // Verifica se o CNPJ tem 14 dígitos
    if (cnpj.length !== 14) {
      return false;
    }

    // Verifica se todos os números são iguais (ex: 11111111111111)
    if (/^(\d)\1{13}$/.test(cnpj)) {
      return false;
    }

    // Verifica os dígitos verificadores
    const cnpjBase = cnpj.slice(0, 12);
    const digitosCalculados = this.calcularDigitosVerificadoresCNPJ(cnpjBase);

    return cnpj.endsWith(digitosCalculados);
  }

  calcularDigitosVerificadoresCNPJ(cnpjBase: string): string {
    let soma1 = 0;
    let soma2 = 0;
    const peso1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const peso2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    // Cálculo do primeiro dígito verificador
    for (let i = 0; i < 12; i++) {
      soma1 += parseInt(cnpjBase.charAt(i)) * peso1[i];
    }
    let digito1 = 11 - (soma1 % 11);
    if (digito1 >= 10) digito1 = 0;

    // Cálculo do segundo dígito verificador
    for (let i = 0; i < 12; i++) {
      soma2 += parseInt(cnpjBase.charAt(i)) * peso2[i];
    }
    soma2 += digito1 * peso2[12];
    let digito2 = 11 - (soma2 % 11);
    if (digito2 >= 10) digito2 = 0;

    return `${digito1}${digito2}`;
  }
}
